var Kowloon = "주룽";
var HKStates = {
	"Hong Kong Island": "홍콩",
	Kowloon: Kowloon,
	"Lantau Island": "란타우섬",
	"New Territories": "신제"
};

export { Kowloon, HKStates as default };
